import {ErrorHandler} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {logConsoleError} from '../../shared-module-ui/utils/logger/logger';

export class GlobalErrorHandler implements ErrorHandler {

  #isDevOrQa = environment.environment === 'Dev' || environment.environment === 'QA';

  handleError(error: Error): void {
    // if (error?.message?.includes('ChunkLoadError')) {
    //   console.warn('ChunkLoadError detected, forcing a reload...');
    //   window.location.reload();
    //   return;
    // }
    /**
     * NG0904: unsafe value used in a resource URL context
     * This error is thrown on the LookerStudio for Dashboard Reporting
     */
    if (error?.message?.includes('NG0904')) {
      return;
    }
    if (!this.#isDevOrQa) {
      console.error('Unhandled Error:', error);
    } else {
      logConsoleError(
        'Unhandled Error:',
        {
          cause: error?.cause ?? 'No cause provided',
          message: error?.message ?? 'No message provided',
          name: error?.name ?? 'Unknown Error',
          stack: error?.stack ? error.stack : 'No stack provided',
        });
    }

    return;
  }
}
